import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { QueryKey } from '@tanstack/react-query'
import { useFarmContext } from 'src/Elements/Farm'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { useTypedSelector } from 'src/State/RootReducer'
import { getWallboxHardware } from '../api/wallbox-hardware.api'
import { usePortalQuery } from 'src/Libs/api'

type UseWallboxHardwareQuery = {
  data: WallboxHardwareModel[] | null
  isLoading: boolean
  isError: boolean
}

export const getWallboxHardwareQueryKey = (storageId: string | undefined): QueryKey => ['wallbox-hardware', storageId]

const useWallboxHardwareQuery = (enabled = true): UseWallboxHardwareQuery => {
  const storageId = useTypedSelector(state => state.storage.activeStorage)
  const authFetch = useAuthFetchWithResponse()
  const { isFarmMasterSelected, isLoading: isFarmLoading } = useFarmContext()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: getWallboxHardwareQueryKey(storageId),
    queryFn: () => getWallboxHardware(storageId, authFetch),
    enabled: enabled && Boolean(storageId) && !isFarmMasterSelected && !isFarmLoading,
  })

  return {
    data: data || null,
    isLoading,
    isError,
  }
}

export default useWallboxHardwareQuery
